console.log("t---");
const currentScript = document.currentScript;

if (currentScript) {
	var id = currentScript.getAttribute("data-id");
}

const overlay = document.getElementById("popup-overlay-" + id);
const popup = document.getElementById("popup-" + id);
const closeBtn = document.getElementById("popup-close-" + id);
const openBtn = document.querySelector(".open-popup-btn");

function openPopup() {
	overlay.classList.add("active");
}

function closePopup() {
	overlay.classList.remove("active");
}

window.addEventListener("load", openPopup);

if (openBtn) {
	openBtn.addEventListener("click", openPopup);
}

// ⭐ Empêche la fermeture en cliquant dans la popup
popup.addEventListener("click", (e) => {
	e.stopPropagation();
});

// ⭐ Ferme si clic sur overlay
overlay.addEventListener("click", () => {
	closePopup();
});

closeBtn.addEventListener("click", () => {
	closePopup();
});
const link = document.createElement("link");
link.rel = "stylesheet";
link.dataset.fontAnton = "true"; // <-- n'a aucun effet sur Google Fonts
link.href = "https://fonts.googleapis.com/css2?family=Anton&display=swap";
document.head.appendChild(link);
